import React from 'react';
import { useLang } from '../context/LangContext';
import LegalPage from '../components/layout/LegalPage';

export default function GdprPage() {
  const { t } = useLang();
  return (
    <LegalPage
      title={t.gdprPage.title}
      lastUpdated={t.gdprPage.lastUpdated}
      sections={t.gdprPage.sections}
      metaTitle={t.meta.gdprTitle}
    />
  );
}
